import React from 'react';
import ContentLoader from 'react-content-loader';


const SidebarLoading = () => (
    <ContentLoader width={80} height={900} primaryColor={"#E3E2E4"} secondaryColor={"#FFFFFF"}>
        <rect x="10" y="10" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="80" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="150" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="220" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="290" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="360" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="430" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="500" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="570" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="640" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="710" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="780" rx="3" ry="3" width="60" height="60" />
        <rect x="10" y="850" rx="3" ry="3" width="60" height="60" />
    </ContentLoader>
)

export default SidebarLoading; 
